const mEditionBillingMyPaymentModalPaymentMethods = {
  mEditionBillingMyPaymentModalPaymentMethods: {
    alerts: {
      changePlan: {
        error: 'Un error ha ocurrido. Verifica los y vuelve a intentarlo.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CONFIRMAR',

    header: {
      title: 'Cambio de Medio de pago'
    }
  }
}

export default mEditionBillingMyPaymentModalPaymentMethods
